/** Options du formulaire de devis (IDs stables ; libellés dans i18n). */

import i18nIsoCountries from 'i18n-iso-countries';
import frLocale from 'i18n-iso-countries/langs/fr.json';

i18nIsoCountries.registerLocale(frLocale);

const allCountriesData = Object.entries(i18nIsoCountries.getNames('fr'))
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, 'fr'));

export const allCountries = [...allCountriesData, { code: 'other', name: 'Autre' }];

export const civilities = ['M.', 'Mme', 'Mlle'];

export const quoteLanguages = [
  'ar', 'fr', 'en', 'it', 'de', 'es', 'ru', 'pt', 'tr', 'zh', 'other',
];

export const translationServices = [
  'official',
  'sworn',
  'certified',
  'legal',
  'technical',
  'medical',
  'financial',
  'commercial',
  'marketing',
  'it',
  'scientific',
  'audiovisual',
  'tourism',
  'literary',
  'luxury',
  'digital',
  'website',
  'softwareLocalization',
  'appLocalization',
  'seo',
];

export const interpretingTypes = [
  'simultaneous',
  'consecutive',
  'liaison',
  'judicial',
  'medical',
  'commercial',
  'phone',
  'video',
];

export const documentTypes = [
  'civilStatus',
  'diploma',
  'passport',
  'idCard',
  'drivingLicense',
  'contract',
  'judgment',
  'notarialAct',
  'medicalReport',
  'technicalManual',
  'catalog',
  'brochure',
  'website',
  'mobileApp',
  'softwareDocs',
  'scientificArticle',
  'cv',
  'letter',
  'other',
];

/** Correspondance vers les tarifs existants du catalogue. */
export const documentTypeProductIds = {
  civilStatus: 'birth',
  diploma: 'diploma',
  passport: 'passport',
  idCard: 'idcard',
  drivingLicense: 'driving',
  contract: 'workContract',
  judgment: 'judgment',
  medicalReport: 'medicalCert',
  technicalManual: 'technicalWebsite',
  website: 'technicalWebsite',
  mobileApp: 'technicalWebsite',
  softwareDocs: 'technicalWebsite',
  scientificArticle: 'academicScientific',
};

export const domains = [
  'legal',
  'medical',
  'technical',
  'commercial',
  'financial',
  'marketing',
  'it',
  'scientific',
  'tourism',
  'luxury',
  'education',
  'industry',
  'other',
];

export const documentFormats = [
  'pdf',
  'word',
  'excel',
  'powerpoint',
  'image',
  'indesign',
  'autocad',
  'html',
  'xml',
  'other',
];

export const translationExtras = [
  'proofreading',
  'sameLayout',
  'certified',
  'sworn',
  'enhancedPrivacy',
];

export const deadlines = ['standard', 'priority', 'urgent', 'exactDate'];

export const missionTypes = [
  'meeting',
  'conference',
  'court',
  'medicalAppointment',
  'training',
  'negotiation',
  'event',
  'tradeShow',
  'other',
];

export const remotePlatforms = ['zoom', 'teams', 'meet', 'webex', 'other'];

export const equipmentOptions = ['booth', 'headsets', 'microphones', 'none'];

export const deliveryModes = ['email', 'secureDownload', 'postal', 'pickup'];

export const countries = [
  'TN', 'FR', 'IT', 'DE', 'BE', 'CH', 'CA', 'AE', 'SA', 'MA', 'DZ', 'other',
];
